import { Channel } from '../types';

export function parseM3U8(content: string): Channel[] {
  const lines = content.split('\n');
  const channels: Channel[] = [];
  let currentChannel: Partial<Channel> = {};
  
  for (let i = 0; i < lines.length; i++) {
    const line = lines[i].trim();
    
    if (line.startsWith('#EXTINF:')) {
      // Parse channel info
      const info = line.substring(8).split(',');
      const name = info[1]?.trim() || 'Unnamed Channel';
      
      // Extract attributes if present
      const tvgName = line.match(/tvg-name="([^"]*)"/)?.[ 1];
      const tvgLogo = line.match(/tvg-logo="([^"]*)"/)?.[ 1];
      const groupTitle = line.match(/group-title="([^"]*)"/)?.[ 1];
      
      currentChannel = {
        name: tvgName || name,
        logo: tvgLogo,
        group: groupTitle || 'Uncategorized',
      };
    } else if (line.startsWith('http')) {
      // Add URL and create channel
      if (currentChannel.name) {
        channels.push({
          id: line,
          name: currentChannel.name,
          url: line,
          group: currentChannel.group || 'Uncategorized',
          logo: currentChannel.logo,
        });
        currentChannel = {};
      }
    }
  }
  
  return channels;
}

export function generateM3U8(channels: Channel[]): string {
  let content = '#EXTM3U\n';
  
  channels.forEach(channel => {
    const attributes = [
      channel.logo ? `tvg-logo="${channel.logo}"` : '',
      `tvg-name="${channel.name}"`,
      `group-title="${channel.group}"`
    ].filter(Boolean).join(' ');
    
    content += `#EXTINF:-1 ${attributes},${channel.name}\n`;
    content += `${channel.url}\n`;
  });
  
  return content;
}
